import { UserManagerService } from './../services/userManager/user-manager.service';
import { HttpService } from './../../wrappers/Http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { BehaviorSubject } from 'rxjs';
import { EndPoints, PaymentEndpoints } from 'src/app/configs';
import { PaymentProvider } from 'src/app/interfaces/payment-provider.model';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  private _mobileActiveAccountstab: number = 1 ;
  betHistoryType: any;
  loadingProviders = true;
  $betHistoryType = new BehaviorSubject('');
  BetTypeDetails = {
    0: "simple",
    1: "multiple",
    2: "system",
    3: "integral"
  }
  getOTP(withdrawalAmt: string): Promise<any> {
    var data = {
      sessionId: this.userService.userData.session,
      amount: withdrawalAmt
    }
    return new Promise((resolve, reject) => {
      this.requestHandler.authPost(this.configService.PROXIES.userService , EndPoints.REQUEST_OTP, data).then(response => {
        if (response.hasOwnProperty("erc") && response.erc == '1') {
          resolve(response)
        } else {
          reject(response)
        }
      })
    })
  }

  public paymentProviders: Record<string | number, PaymentProvider[]> = {};
  private _activeAccountstab = 1;
  private _usersbanks: Array<any>;
  public get usersbanks(): Array<any> {
    return this._usersbanks;
  }
  public set usersbanks(value: Array<any>) {
    this._usersbanks = value;
  }
  private _tabs: Array<any> = [];
  public get tabs(): Array<any> {
    return this._tabs;
  }
  public set tabs(value: Array<any>) {
    this._tabs = value;
  }

  public get activeAccountstab(): number {
    return this._activeAccountstab;
  }
  public set activeAccountstab(value: number) {
    this._activeAccountstab = value;
  }
  public get mobileActiveAccountstab(): number {
    return this._mobileActiveAccountstab;
  }
  public set mobileActiveAccountstab(value: number) {
    this._mobileActiveAccountstab = value;
  }
  paymentProviders$ = new BehaviorSubject<Record<string | number, PaymentProvider[]>>({"1": [], "2": []});

  constructor(private requestHandler: HttpService, private userService: UserManagerService, private configService: ConfigService) { }

  getProviders(id: number): Promise<any> {
    const api = id === 1 ? 'cashInProviders' : 'cashOutProviders';
    if(this.paymentProviders[id]){
      return Promise.resolve(this.paymentProviders[id]);
    }
    this.loadingProviders = true;
    return this.requestHandler.get_request(this.configService.PROXIES.userService , EndPoints.providers + api, {}, true).then(response => {
      const providers = [];
      response.data.forEach(element => {
        if (element.hasOwnProperty('sub_providers') && element.sub_providers.length > 0) {
          element.sub_providers.forEach(subProv => {

            providers.push(this.buildProvObj(subProv, element));
          });
        } else {
          // element.pdv = element.code;
          providers.push(this.buildProvObj(element, element));
        }
      });
      this.paymentProviders[id] = providers;

      if (id == 2){
        let context = this;
      if(context.userService.userData&&context.userService.userData.providers && context.userService.userData.providers.length > 0){
        context.userService.userData.providers = this.setProvPhoneNumbers(context.userService.userData.providers);
        this.paymentProviders[2]  = this.paymentProviders[2].filter(function(array_el){
          // console.log('filtering')
          return context.userService.userData.providers.filter(function(anotherOne_el){
             return (anotherOne_el.pvd == array_el.code || !array_el.is_mobile);
          }).length >= 1
       });

      }
      else{
        this.paymentProviders[2]  = this.paymentProviders[2].filter(function(array_el){
             return (!array_el.is_mobile);
       });
      }
      //  console.log(this.paymentProviders[2], "filtered object")
      }
      // console.log(this.paymentProviders);
      this.paymentProviders$.next(this.paymentProviders);
      this.loadingProviders = false;
      // console.log(providers)
    });
  }

  buildProvObj(subProv, element){
    subProv.pdv = element.code;
    return subProv;
  }
  setProvPhoneNumbers(providers:Array<any>){
    providers.forEach(subProv=>{
      if(subProv.accnt && subProv.accnt.startsWith(this.configService.country_code)){
        subProv.accnt = subProv.accnt.split(this.configService.country_code)[1]
      }
     })

     return providers;

  }
  triggerWithdrawal(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(this.configService.PROXIES.userService , PaymentEndpoints[arg0], accountParams, );
  }
  triggerDeposit(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(this.configService.PROXIES.userService , PaymentEndpoints[arg0], accountParams);
  }
  getUserBanks() {
    // this.requestHandler.get_request(this.configService.PROXIES.userService + 'account/' + this.userService.userData.customer_ID, {}).then(responseData => {
    //   this.usersbanks = responseData;
    // });
  }
  validateOTP(accountParams: any) {
    return this.requestHandler.authPost(this.configService.PROXIES.userService , EndPoints[accountParams['pdvurl'] + '_CONFIRMATION'], accountParams);
  }

  getBonusDetails(params): Promise<any> {
    // return this.requestHandler.Hget(this.configService.PROXIES.userService.split('v2/')[0], EndPoints.getBonusDetails, params);
    return this.requestHandler.Hget(this.configService.PROXIES.userService, EndPoints.getBonusTransDetails + params.bonusId, {});
  }

  getBonusUsageDetails(params): Promise<any> {
    return this.requestHandler.get_no_auth(this.configService.PROXIES.userService.split('v2/')[0] + EndPoints.getBonusUsageDetails, params);
  }

  getBonusTransactions(params: any): Promise<any> {
    const {customer_ID} = this.userService.userData;

    return this.requestHandler.get_request(
      this.configService.PROXIES.userService,
      EndPoints.bonus_transactions + customer_ID,
      params
    )
  }
}
